import DataMgr from "@/Fwk/DataMgr";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {AccountSelectionDialogFC, UserType} from "@/app/_dialogs/AccountSelectionDialog/AccountSelectionDialog";
import {PrivacyDialogFC} from "@/app/_dialogs/PrivacyDialog/PrivacyDialog";
import RouterMgr from "@/Core/RouterMgr";
import UserMgr from "@/Core/UserMgr";


export enum GuiderConst {
    guide_id_key = 'guide_id' ,
}

export enum GuideIDType {
    guide_null = 0 ,
    guide_1001 = 1001,
    guide_end = -1,
}


export default class GuideMgr {

    static get isGuideEnd(){
        const loadGuide = DataMgr.getStorage(GuiderConst.guide_id_key);
        return loadGuide ===GuideIDType.guide_end;
    }

    static setGuideId(id:GuideIDType){
        DataMgr.setStorage('guide_id',id);
        UserMgr.updateUser('UpdateUserInfo',{
            guideID:id
        });
    }

    static show(){
        SDialogManagerFC.openDialog(AccountSelectionDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(AccountSelectionDialogFC),
            callToLogin:(loginType:UserType)=>{
                if (loginType === UserType.visitor) {
                    SDialogManagerFC.openDialog(PrivacyDialogFC,{
                        fcKey:SDialogManagerFC.getFCKey(PrivacyDialogFC),
                        callAccept:()=>{
                        }
                    })
                } else if (loginType === UserType.normal) {
                    RouterMgr.push('/login');
                }
            }
        })
    }

}